module.exports = __webpack_public_path__ + "media/images/exclamation-858caf4b8bc63551bcc58df24a8e4de1.png";